module.exports = __webpack_public_path__ + "static/media/1-street-bob-leds-light-beam-compressed.c3628421.png";